import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-invitation-developer',
  templateUrl: './invitation-developer.component.html',
  styleUrls: ['./invitation-developer.component.scss'],
})
export class InvitationDeveloperComponent extends BaseCtl {
  public token: string | undefined;
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.collaborator')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  // public statusList = ['Accept', 'Reject'];

  override ngOnInit() {
    let _self = this;
    const url = window.location.href;
    const hashIndex = url.indexOf('#');
    if (hashIndex !== -1) {
      const hashParams = url.substring(hashIndex + 1);
      const paramsArray = hashParams.split('/');
      if (paramsArray.length >= 3) {
        _self.decodeBase64(paramsArray[2]);
      }
    }
  }

  public isValidToken = true;

  /**
   * Decode Base64 to and get Data
   * @param encodedString
   * @returns
   */
  decodeBase64(encodedString: string): any {
    let _self = this;
    try {
      const decodedObject = JSON.parse(atob(decodeURIComponent(encodedString)));
      const currentTime = new Date().toISOString();
      if (decodedObject.expiry && currentTime > decodedObject.expiry) {
        _self.isValidToken = false;
        _self.form['message'] = 'Your Link has expired';
        console.error('Token has expired');
        alert('Token has expired');
        return;
      }
      Object.assign(_self.form.data, {
        userId: decodedObject['userId'],
        orgId: decodedObject['orgId'],
        loginId: decodedObject['loginId'],
        applicationId: decodedObject['applicationId'],
        role: decodedObject['role'],
        status: 'Accept',
      });

      _self.saveInvitation();
      return decodedObject;
    } catch (error) {
      console.error('Invalid token', error);
    }
  }

  /**
   * Save invitation
   */
  public saveInvitation() {
    let _self = this;

    console.log(_self.form['data']);

    _self.locator.config
      .getProperty('endpoint.collaborator')
      .then((property: string) => {
        let url = property + '/public/inviteResponse';
        _self.locator.http.post(
          url,
          _self.form['data'],
          (res: any, error: boolean) => {
            if (error) {
              alert('Server Error:' + error);
              return;
            }
            _self.form['error'] = !res.success;
            _self.form['message'] = res.message;
            if (res.result?.inputerror?.key) {
              _self.form['message'] = res.result['inputerror']['key'];
            } else {
            _self.form['inputerror'] = res.result['inputerror'];
            }

            if (res.success) {
              if (res.result.data === 'login') {
                _self.locator.router.navigateByUrl('/login');
              }
              if (res.result.data === 'signUp') {
                _self.locator.router.navigateByUrl('/signupInvitation');
              }
            }
          }
        );
      });
  }

  gotoLogin() {
    this.forward('login');
  }
}
